import { render, staticRenderFns } from "./putlinkXcx.vue?vue&type=template&id=7ccc7016&scoped=true"
import script from "./putlinkXcx.vue?vue&type=script&lang=js"
export * from "./putlinkXcx.vue?vue&type=script&lang=js"
import style0 from "./putlinkXcx.vue?vue&type=style&index=0&id=7ccc7016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccc7016",
  null
  
)

export default component.exports